module.exports = __webpack_public_path__ + "37ba7b92/img/dollar-icon.35c9d638.svg";